import React, {useEffect} from 'react';
import Cookie from 'js-cookie';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import Typography from '../../../components/common/Typography';
import RimacLogo from '../../../components/common/RimacLogo';
import UserRimacSentado from '../../../assets/brothercito_sentado_escritorio.svg';
import authDuck from '../../../reducers/authDuck';
import { inicioRoute } from '../../../utils/helpers';

const { signOut } = authDuck.creators;

const LayoutLogin = ({ children }) => {
    const isAuthenticated = Cookie.get('POWERIMAC_ROL');
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (isAuthenticated) {
            const to = location.state ? location.state.from.pathname : inicioRoute();
            history.push(to);
        } else {
            const congnitoSign = Object.keys(window.localStorage).some((key) =>
                key.startsWith('CognitoIdentityServiceProvider')
            );
            if (congnitoSign) {
                dispatch(signOut());
            }
        }
    }, [isAuthenticated, history, dispatch]);

    return (
        <div className="login">
            <div className="login__header">
                <div className="login__header-left">
                    <div className="login__header-content">
                        <RimacLogo />
                    </div>
                </div>
                <div className="login__header-right">
                    <div className="login__header-empty" />
                </div>
            </div>
            <div className="login__body">
                <div className="login__left">
                    <div className="login__info">
                        <div className="mt_7">
                            <Typography font="primary" color="gray1" weight="bold" component="h2" className="mr_2">
                                Descubre
                            </Typography>
                            <Typography font="primary" color="red1" weight="bold" component="h2">
                                Power Rimac
                            </Typography>
                            <Typography
                                weight="normal"
                                font="secondary"
                                className="login__description"
                                color="gray1"
                            >
                                Aquí podrás realizar la gestión de tu equipo y darle seguimiento.
                            </Typography>
                        </div>
                        <div>
                            <Typography
                                weight="thin"
                                color="gray2"
                                className="login__footer"
                                font="secondary"
                            >
                                © 2021 RIMAC Seguros y Reaseguros.
                            </Typography>
                        </div>
                        <div className="login__box-user">
                            <img src={UserRimacSentado} alt="usuario" />
                        </div>
                    </div>
                </div>
                <div className="login__right">
                    <div className="login__children mt_8">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default LayoutLogin;
